export default {"src":"/_next/static/media/img-price-test-product.802bfc1e.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};